module.exports = __webpack_public_path__ + "img/listing.5bb8a1c3.svg";